/**
 * DevExtreme (esm/__internal/scheduler/m_classes.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const FIXED_CONTAINER_CLASS = "dx-scheduler-fixed-appointments";
export const REDUCED_APPOINTMENT_CLASS = "dx-scheduler-appointment-reduced";
export const REDUCED_APPOINTMENT_ICON = "dx-scheduler-appointment-reduced-icon";
export const RECURRENCE_APPOINTMENT_CLASS = "dx-scheduler-appointment-recurrence";
export const EMPTY_APPOINTMENT_CLASS = "dx-scheduler-appointment-empty";
export const ALL_DAY_APPOINTMENT_CLASS = "dx-scheduler-all-day-appointment";
export const REDUCED_APPOINTMENT_PARTS_CLASSES = {
  head: "dx-scheduler-appointment-head",
  body: "dx-scheduler-appointment-body",
  tail: "dx-scheduler-appointment-tail"
};
export const DIRECTION_APPOINTMENT_CLASSES = {
  horizontal: "dx-scheduler-appointment-horizontal",
  vertical: "dx-scheduler-appointment-vertical"
};
export const APPOINTMENT_DRAG_SOURCE_CLASS = "dx-scheduler-appointment-drag-source";
export const APPOINTMENT_ITEM_CLASS = "dx-scheduler-appointment";
export const APPOINTMENT_CONTENT_CLASSES = {
  APPOINTMENT_CONTENT_DETAILS: "dx-scheduler-appointment-content-details",
  RECURRING_ICON: "dx-scheduler-appointment-recurrence-icon",
  APPOINTMENT_TITLE: "dx-scheduler-appointment-title",
  APPOINTMENT_DATE: "dx-scheduler-appointment-content-date",
  ALL_DAY_CONTENT: "dx-scheduler-appointment-content-allday",
  ARIA_DESCRIPTION: "dx-scheduler-appointment-aria-description",
  ITEM: "dx-scheduler-appointment",
  STRIP: "dx-scheduler-appointment-strip",
  AGENDA_MARKER: "dx-scheduler-agenda-appointment-marker",
  AGENDA_RESOURCE_LIST: "dx-scheduler-appointment-resource-list",
  AGENDA_RESOURCE_LIST_ITEM: "dx-scheduler-appointment-resource-item",
  AGENDA_RESOURCE_LIST_ITEM_VALUE: "dx-scheduler-appointment-resource-item-value"
};
export const AGENDA_LAST_IN_DATE_APPOINTMENT_CLASS = "dx-scheduler-last-in-date-agenda-appointment";
export const APPOINTMENT_HAS_RESOURCE_COLOR_CLASS = "dx-scheduler-appointment-has-resource-color";
export const HEADER_CURRENT_TIME_CELL_CLASS = "dx-scheduler-header-panel-current-time-cell";
export const VIRTUAL_CELL_CLASS = "dx-scheduler-virtual-cell";
export const TIME_PANEL_CLASS = "dx-scheduler-time-panel";
export const DATE_TABLE_CLASS = "dx-scheduler-date-table";
export const DATE_TABLE_ROW_CLASS = "dx-scheduler-date-table-row";
export const GROUP_ROW_CLASS = "dx-scheduler-group-row";
export const GROUP_HEADER_CONTENT_CLASS = "dx-scheduler-group-header-content";
export const LAST_GROUP_CELL_CLASS = "dx-scheduler-last-group-cell";
export const FIRST_GROUP_CELL_CLASS = "dx-scheduler-first-group-cell";
export const VERTICAL_GROUP_COUNT_CLASSES = ["dx-scheduler-group-column-count-one", "dx-scheduler-group-column-count-two", "dx-scheduler-group-column-count-three"];